import ParameterStore from "../parameters/ParameterStore";
import CommonParameter from "../parameters/CommonParameter";
import LogRequester from "../requesters/LogRequester";
import ImplicitLogSchemas from "../config/ImplicitLogSchemas";
import ConsoleLog from "../utils/ConsoleLog";
import RequestUtil from "../utils/RequestUtil";
import EventUtil from "../utils/EventUtil";

export default class Click {
  commonData: CommonDataType;
  commonParameter: CommonParameter;
  parameterStore: ParameterStore;
  campaignParams: CampaignParamType;
  logRequester: LogRequester;
  constructor(parameterStore: ParameterStore,
              commonParameter: CommonParameter,
              commonData: CommonDataType,
              campaignParams: CampaignParamType,
              logRequester: LogRequester) {
    this.commonData = commonData;
    this.commonParameter = commonParameter;
    this.parameterStore = parameterStore;
    this.campaignParams = campaignParams;
    this.logRequester = logRequester;
  }

  clickHandler(e: Event) {
    const elem = e.target as HTMLElement;
    const target = EventUtil.getElemToTrackForClick(elem);

    if (target) {
      const params = RequestUtil.generateEventData('click', target, this.parameterStore, this.commonData);
      const updatedParams = RequestUtil.generateImplicitLogRequestParams(ImplicitLogSchemas.Click, params, this.commonData)
      const requestJSON = RequestUtil.generateRequestJSON(updatedParams, this.commonParameter, this.campaignParams);

      this.logRequester.send(requestJSON, true);
      ConsoleLog.d('Click', '#trigger click event');
    }
  }
}
